import axios from "axios";

export const incrementReferral = (hash) =>
  axios({
    method: "PUT",
    url: "/api/v1/referral-link",
    data: { referral_hash: hash },
  });
